/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
export const useCustomFieldStore = defineStore("customFieldStore", {
  state: () => ({
    customFieldLists: [],
    customFieldNotSet: false,
    customFieldToDelete: null,
    customFieldSummary: {},
    showDeleteCustomFieldsModal: false,
    showUpdateCustomFieldModal: false,
    selectedCustomField: {},
    alerts: {}
  }),
  actions: {
    async listCustomField() {
      try {
        const response = await axios({
          url: "/customFields"
        });
        if (!response.data.customFields.length) {
          this.customFieldNotSet = true;
          this.customFieldLists = [{
            name: "Sample Data Field Name",
            QBOCustomField: "",
            showOnClient: true,
            type: "Text",
            active: true
          }, {
            name: "Another Sample",
            QBOCustomField: "Sample Mapped to QBO",
            showOnClient: true,
            type: "Text",
            active: false
          }];
          return;
        }
        this.customFieldLists = response.data.customFields;
        this.customFieldLists.forEach(customField => {
          if (customField.showOnClient) {
            customField.entity = "Client";
          }
          if (customField.showOnMatter) {
            customField.entity = "Matter";
          }
        });
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async createCustomField(customField) {
      try {
        const response = await axios({
          url: "/customFields",
          method: "POST",
          data: customField
        });
        this.customFieldLists.push(response.data);
        this.alerts.success("Custom Field Created Successfully");
        this.showUpdateCustomFieldModal = false;
        this.selectedCustomField = {};
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    toggleDeleteCustomFieldsModal(customField) {
      this.customFieldToDelete = customField;
      this.showDeleteCustomFieldsModal = !this.showDeleteCustomFieldsModal;
    },
    async loadCustomFieldSummary(customFieldId) {
      try {
        const response = await axios({
          url: `/customFields/${customFieldId}/summary`,
          method: "GET"
        });
        this.customFieldSummary = response.data;
      } catch (error) {
        this.alerts.error(error);
      }
    }
  }
});